// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

export class Popup extends EventTarget {
  constructor() {
    super();
    this.popup = document.createElement("div");
    this.popup.style.position = "absolute";
    this.popup.style.width = "100vw";
    this.popup.style.height = "100vh";
    this.popup.style.left = 0;
    this.popup.style.top = 0;
    this.popup.style.display = "flex";
    this.popup.style.justifyContent = "center";
    this.popup.style.alignItems = "center";
    this.popup.style.backdropFilter = "blur(10px)";
    this.popup.style.zIndex = 2000;

    this.popupBox = document.createElement("div");
    this.popupBox.style.width = "fit-content";
    this.popupBox.style.padding = "10px 20px";
    this.popupBox.style.background = "#FFFFFF";
    this.popupBox.style.display = "flex";
    this.popupBox.style.flexDirection = "column";
    this.popupBox.style.justifyContent = "center";
    this.popupBox.style.alignItems = "center";
    this.popupBox.style.borderRadius = "10px";
    this.popupBox.style.border = "1px solid #CCCCCC";
    this.popupBox.style.boxShadow = "0 0 10px #00000033";
    this.popupBox.style.transform = "scale(0)";
    this.popupBox.style.transition = "transform 0.3s ease-out";
    this.popup.appendChild(this.popupBox);
    this.popupBox.addEventListener("transitionend", (e) => {
      if (e.propertyName === "transform") {
        let style = window.getComputedStyle(this.popupBox);
        let transform = style.transform;
        let values = transform.split("(")[1].split(")")[0].split(",");
        let scaleX = parseFloat(values[0]);
        if (scaleX == 0) {
          this.popup.style.display = "none";
        }
      }
    });

    this.msg = document.createElement("div");
    this.msg.style.color = "#666666";
    this.msg.style.fontSize = "14px";
    this.msg.style.textAlign = "center";
    this.popupBox.appendChild(this.msg);

    this.btnContaier = document.createElement("div");
    this.btnContaier.style.marginTop = "20px";
    this.btnContaier.style.display = "flex";
    this.btnContaier.style.width = "50%";
    this.btnContaier.style.justifyContent = "center";
    this.btnContaier.style.gap = "10px";
    this.popupBox.appendChild(this.btnContaier);
  }
  show(message, buttons) {
    this.msg.innerText = message;
    this.btnContaier.innerHTML = "";
    buttons.forEach((button) => {
      let btn = document.createElement("button");
      btn.id = button.id;
      btn.textContent = button.caption;
      btn.style.padding = "5px 10px";
      btn.style.border = "none";
      btn.style.borderRadius = "5px";
      btn.style.color = "#FFFFFF";
      btn.style.fontSize = "12px";
      btn.classList.add("popupButton");
      this.btnContaier.appendChild(btn);
    });
    document.body.appendChild(this.popup);
    this.popup.style.display = "flex";
    setTimeout(() => {
      this.popupBox.style.transform = "scale(1)";
    }, 0);
  }
  hide() {
    this.popupBox.style.transform = "scale(0)";
  }
}
